import React from 'react';
import StaticPageLayout from './StaticPageLayout';

const PrivacyPolicyPage = () => {
  return (
    <StaticPageLayout title="Privacy Policy">
      <p className="static-page__muted">Last updated: Feb 10, 2026</p>

      <p>
        This Privacy Policy explains what data we collect, how we use it, and
        what choices you have when using Zoomed In.
      </p>

      <h3>Information we collect</h3>
      <ul>
        <li>
          <strong>Account data (if you sign in)</strong>: email address and basic
          profile information used for authentication and account access.
        </li>
        <li>
          <strong>Gameplay data</strong>: things like game progress, scores, and
          settings to make the app work and improve it.
        </li>
        <li>
          <strong>Coins and transaction records</strong>: virtual currency
          balances, purchase history, and anti-fraud records needed to deliver
          paid features.
        </li>
        <li>
          <strong>Device/usage data</strong>: basic technical information (for
          example browser type, timestamps, and request metadata) that may be
          collected for security, analytics, or reliability.
        </li>
      </ul>

      <h3>Payment information</h3>
      <p>
        Payments are processed by third-party payment providers (for example,
        Stripe). We do not store full card numbers in our app database. We may
        store payment-related metadata such as transaction IDs, status, and coin
        fulfillment records.
      </p>

      <h3>Cookies and ads</h3>
      <p>
        We may display ads using Google AdSense. AdSense and its partners may use
        cookies or similar technologies to show ads, measure performance, and
        personalize ads depending on your settings and region.
      </p>

      <h3>Third-party services</h3>
      <ul>
        <li>
          <strong>Authentication / database</strong>: we use Supabase to power
          sign-in and store game-related data.
        </li>
        <li>
          <strong>Payments</strong>: we use payment providers (for example,
          Stripe) to process purchases securely.
        </li>
        <li>
          <strong>Advertising</strong>: we may use Google AdSense to display ads.
        </li>
        <li>
          <strong>Images</strong>: some modes use third-party image providers
          (for example, Pexels) and mapping/street-view providers.
        </li>
      </ul>

      <h3>How we use information</h3>
      <ul>
        <li>Provide core gameplay and account features.</li>
        <li>Process purchases, coin fulfillment, refunds, and dispute handling.</li>
        <li>Maintain security and prevent abuse.</li>
        <li>Improve performance and reliability.</li>
        <li>Support the app with ads (if enabled).</li>
      </ul>

      <h3>Data retention</h3>
      <p>
        We keep data for as long as needed to operate the app, maintain account
        history, prevent fraud, and satisfy legal obligations. We may delete or
        anonymize data when no longer required.
      </p>

      <h3>Security</h3>
      <p>
        We use reasonable administrative and technical safeguards, but no method
        of storage or transmission is 100% secure.
      </p>

      <h3>Your choices</h3>
      <ul>
        <li>You can choose not to create an account and still play.</li>
        <li>
          You can use browser settings to block or clear cookies (note: this may
          affect site functionality).
        </li>
        <li>
          You can contact us to request account-related help, including data
          access or deletion requests where applicable.
        </li>
      </ul>

      <h3>Children</h3>
      <p>
        Zoomed In is not intended for children under 13. If you believe a child
        has provided personal information, contact us so we can review and
        remove it where appropriate.
      </p>

      <h3>Policy updates</h3>
      <p>
        We may update this Privacy Policy from time to time. The latest version
        will always be posted on this page with the updated date.
      </p>

      <h3>Contact</h3>
      <p>
        If you have privacy questions, contact us at{' '}
        <a href="mailto:imran@playgroundlogic.com">imran@playgroundlogic.com</a>.
      </p>
    </StaticPageLayout>
  );
};

export default PrivacyPolicyPage;

